import { DefaultError, useMutation } from '@tanstack/react-query';
import {
  getExternalAuthRedirected,
  GetExternalAuthRedirectedOptions,
} from 'shared/services/backend-api';
import { getErrorReporter } from 'shared/services/error-tracking';

export const useRedirectToExternalAuthMutation = () =>
  useMutation<void, DefaultError, GetExternalAuthRedirectedOptions>({
    mutationFn: async (options) => await getExternalAuthRedirected(options),
    onError: (error) => {
      getErrorReporter().captureException(error, {
        tags: { source: 'external-calendar-auth-redirect' },
      });
    },
  });
